/** @typedef {import("../../api/types").Client} Client */
import React, {useEffect, useState} from "react";
import axios from "axios";
import AddressLink from "../../shared/components/AddressLink";
import EmailLink from "../../shared/components/EmailLink";
import Field from "../../shared/components/Field";
import PhoneLink from "../../shared/components/PhoneLink";
import {Link, useParams} from "react-router-dom";
import {Alert, Button, Card, CardBody, Container, Spinner} from "reactstrap";
import ListLink from "../../shared/components/ListLink";
import IconLabel from "../../shared/components/IconLabel";
import {PencilIcon} from "../../shared/components/icons";

const CLIENTS_URL = "/os/api/clients/";

const ClientDetail = () => {
    const {id} = useParams();
    const [client, setClient] = useState(/** @type {Client|null} */ (null));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        setError(null);
        setClient(null);

        axios
            .get(`${CLIENTS_URL}${encodeURIComponent(id)}/`, {signal: controller.signal})
            .then(({data}) => setClient(data))
            .catch((err) => {
                if (axios.isCancel(err)) return;
                setError(
                    err.response?.status === 404 ? "Cliente não encontrado." : "Não foi possível carregar o cliente."
                );
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, [id]);

    return (
        <Container className="mt-4 mb-5">
            <ListLink basePath="/clients">&larr; Clientes</ListLink>
            {loading && (
                <div className="text-center mt-4">
                    <Spinner />
                </div>
            )}
            {error && (
                <Alert color="danger" className="mt-3">
                    {error}
                </Alert>
            )}
            {client && (
                <>
                    <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                        <h3 className="mb-0">{client.name}</h3>
                        <Button color="primary" outline tag={Link} to={`/clients/${id}/edit`}>
                            <IconLabel icon={<PencilIcon size={16} />}>Editar</IconLabel>
                        </Button>
                    </div>
                    <Card>
                        <CardBody>
                            <Field label="Telefone" value={client.phone}>
                                <PhoneLink phone={client.phone} />
                            </Field>
                            <Field label="Telefone alternativo" value={client.alternate_phone}>
                                <PhoneLink phone={client.alternate_phone} />
                            </Field>
                            <Field label="E-mail" value={client.email}>
                                <EmailLink email={client.email} />
                            </Field>
                            <Field label="Endereço" value={client.address}>
                                <AddressLink address={client.address} />
                            </Field>
                        </CardBody>
                    </Card>
                </>
            )}
        </Container>
    );
};

export default ClientDetail;
